import React, {useState,useEffect,useRef} from 'react'
import { Formik, Field } from 'formik'
import { Table,Button,Icon,Form,Select,Input,List,Image,Label,TextArea,Message } from 'semantic-ui-react'

import {WindowReload, WindowURL, WindowLocation} from '../../config/settings'
import Alertmessage from '../../config/alert'
import axios from 'axios'
import renderHTML from 'react-render-html'
import {validateStep2} from './validate'


export default function OpenAccountStep2(props) {

	function CallbackFunction(data){
		props.active(data);
	}
  function CallbackState(data){
    props.callstate(data);
  }

	/*-------------------------------------------------------------------------
	 Forms: Adding
	--------------------------------------------------------------------------*/
	const [state,setstate] = useState({
		username:props.state.username,
		password:props.state.password,
		confirm_password:props.state.confirm_password,
		secquestion_1:props.state.secquestion_1,
		secquestion_1_answer:props.state.secquestion_1_answer,
	});

	function handleSubmitForm(values, props){

		CallbackState({
      username:values.username,
  		password:values.password,
  		confirm_password:values.confirm_password,
  		secquestion_1:values.secquestion_1,
  		secquestion_1_answer:values.secquestion_1_answer,
    });
    CallbackFunction(3);

	}

	/*-------------------------------------
	 	Queries
	--------------------------------------*/
	const [repslist, setrepslist] = useState([]);
	const [countries, setcountries] = useState([]);
	const [seclist, setseclist] = useState([]);

	function ApplicationQuries(){
		let formData = new FormData();
		formData.append('type','query_application');
		axios.post('/application/http.php',formData)
		.then(function (response) {
				let obj = response.data;
				setrepslist(obj.reps);
				setcountries(obj.countries);
				setseclist(obj.seclist);
		})
		.catch(function (error){
		});
	}


	/*-------------------------------------
		Content
	--------------------------------------*/
	const [content, setcontent] = useState({
			form: {
				app:'',
				step2: {
					title:'',
					content:'',
					message:'',
				},
				country: {
					title:'',
					content:'',
				}
			},
	});
	function ContentApplication(){
		let formData = new FormData();
		formData.append('type','content');
		axios.post('/content/request.php',formData)
		.then(function (response) {
				let obj = response.data;
				setcontent({
					...content,
					form: {
						step2: {
							title:obj.form.step2.title,
							content:obj.form.step2.content,
							message:obj.form.step2.message,
						},
						country: {
							title:obj.form.country.title,
							content:obj.form.country.content,
						}
					},
				});
		})
		.catch(function (error){
		});
	}


	useEffect(()=>{
		ApplicationQuries();
		ContentApplication();
	},[]);

	return (
		<React.Fragment>
				<Form>
					<Formik
					  enableReinitialize
						initialValues={state}
						validationSchema={validateStep2}
						onSubmit={handleSubmitForm}
						render={formProps => {
						const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, touched, setFieldValue } = formProps
						return(
			         <div className="open-account-panel">
                 <div className="open-account-panel-header">
									 <h2>{content.form.step2.title}</h2>
									 {content.form.step2.content!=''?renderHTML(content.form.step2.content):''}
									<Message visible negative>{content.form.step2.message}</Message>
                </div>
			            <div className="open-account-panel-body">

									<div className="open-account-body-wrapper">

                      <div className="application-box">
											  <h3>Provide Username and Password</h3>
			                  <Form.Group widths="equal">
			                    <Field name="username">
			                        {({ field, form }) => (
			                        <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Username</label>
			                          <Input {...field} onChange={handleChange}/>
			                          { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
			                        </Form.Field>
			                        )}
			                    </Field>
			                  </Form.Group>
												<Form.Group widths="equal">
			                    <Field name="password">
			                        {({ field, form }) => (
			                        <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Password</label>
			                          <Input {...field} onChange={handleChange}/>
			                          { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
			                        </Form.Field>
			                        )}
			                    </Field>
			                  </Form.Group>
												<Form.Group widths="equal">
			                    <Field name="confirm_password">
			                        {({ field, form }) => (
			                        <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Confirm Password</label>
			                          <Input {...field} onChange={handleChange}/>
			                          { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
			                        </Form.Field>
			                        )}
			                    </Field>
			                  </Form.Group>
										 </div>
									</div>{/*.open-account-body-wrapper*/}

									<div className="application-box topspace">
										  <h3>Select Security Questions and Answers</h3>
											<Form.Group widths="equal">
												<Field name="secquestion_1">
													{({ field, form }) => (
															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Security question one</label>
																<Select selectOnBlur={false}
																		{...field}
																		options={seclist}
																		onChange={(e, { value }) => {
																			setFieldValue(field.name,value);
																		}}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
													)}
												</Field>
												<Field name="secquestion_1_answer">
														{({ field, form }) => (
														<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<label>Security answer one</label>
															<Input {...field} onChange={handleChange}/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
														)}
												</Field>
											</Form.Group>

											{/*
											<Form.Group widths="equal">
												<Field name="secquestion_2">
													{({ field, form }) => (
															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Security question two</label>
																<Select selectOnBlur={false}
																		{...field}
																		options={seclist}
																		onChange={(e, { value }) => {

																			if(value==values.secquestion_1||value==values.secquestion_3){
																				setAlertcontent({intent:'alert',settings:{centered:true,icon:'warning',title:'Selection Error!',html:"Already selected. Please select other questions."}});
																			  setalert(true);
																				setFieldValue(field.name,'');
																				setTimeout(function() {setalert(false);},3000);
																				return false;
																			}
																			setFieldValue(field.name,value);

																		}}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
													)}
												</Field>
												<Field name="secquestion_2_answer">
														{({ field, form }) => (
														<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<label>Security answer two</label>
															<Input {...field} onChange={handleChange}/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
														)}
												</Field>
											</Form.Group>
											<Form.Group widths="equal">
												<Field name="secquestion_3">
													{({ field, form }) => (
															<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<label>Security question three</label>
																<Select selectOnBlur={false}
																		{...field}
																		options={seclist}
																		onChange={(e, { value }) => {

																			if(value==values.secquestion_1||value==values.secquestion_2){
																				setAlertcontent({intent:'alert',settings:{centered:true,icon:'warning',title:'Selection Error!',html:"Already selected. Please select other questions."}});
																			  setalert(true);
																				setFieldValue(field.name,'');
																				setTimeout(function() {setalert(false);},3000);
																				return false;
																			}
																			setFieldValue(field.name,value);

																		}}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
													)}
												</Field>
												<Field name="secquestion_3_answer">
														{({ field, form }) => (
														<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<label>Security answer three</label>
															<Input {...field} onChange={handleChange}/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
														)}
												</Field>
											</Form.Group>
											*/}


										</div>
									</div>{/*.panel-body*/}
			            <div className="open-account-panel-footer">
										<div className="account-panel-footer">
											<div><Button content='Back' className="primary" icon='left arrow' labelPosition='left' onClick={()=>CallbackFunction(1)}/></div>
											<div><Button content='Continue' className="primary" icon='right arrow' labelPosition='right' onClick={handleSubmit}/></div>
										</div>
									</div>
			         </div>

						 )}}/>
					</Form>
    </React.Fragment>
  )
}
